import api from './api'

const DEFAULT_SHARE = {
  title: '北外滩国际航运论坛',
  desc: '北外滩国际航运论坛唯一官网',
  imgUrl: window.location.origin + '/share-logo.png',
}

let callId = 0

// iOS 微信要求用 webview「首次加载」的入口 URL 签名，而非 SPA 路由跳转后的当前 URL。
// 模块首次执行（任何前端路由跳转之前）记录一次，作为签名 URL。
const ENTRY_URL = window.location.href.split('#')[0]

/**
 * 初始化微信分享
 * @param {Object} shareData - { title, desc, link, imgUrl }
 */
export function initWxShare(shareData = {}) {
  if (!/micromessenger/i.test(navigator.userAgent)) return

  const wx = window.wx
  if (!wx) return

  const currentCallId = ++callId
  const currentUrl = window.location.href.split('#')[0]
  // imgUrl 兼容两种形态：直接的 url 字符串，或上传字段返回的 { url } 对象
  const rawImg = shareData.imgUrl
  const imgUrl = (rawImg && typeof rawImg === 'object' ? rawImg.url : rawImg) || DEFAULT_SHARE.imgUrl
  const data = {
    title: shareData.title || DEFAULT_SHARE.title,
    desc: shareData.desc || DEFAULT_SHARE.desc,
    link: shareData.link || currentUrl,
    imgUrl,
  }

  api.get('/api/weixin/jssdk_config', { url: ENTRY_URL }).then(res => {
    if (currentCallId !== callId) return

    wx.config({
      debug: res.debug || false,
      appId: res.appId,
      timestamp: parseInt(res.timestamp, 10),
      nonceStr: res.nonceStr,
      signature: res.signature,
      jsApiList: res.jsApiList || [
        'updateAppMessageShareData',
        'updateTimelineShareData',
      ],
    })

    wx.ready(function () {
      wx.updateAppMessageShareData({
        title: data.title,
        desc: data.desc,
        link: data.link,
        imgUrl: data.imgUrl,
      })
      wx.updateTimelineShareData({
        title: data.title,
        link: data.link,
        imgUrl: data.imgUrl,
      })
    })

    wx.error(function (res) {
      console.error('wx.config error:', res)
    })
  }).catch(err => {
    console.error('获取 JSSDK 配置失败:', err)
  })
}
